import { Component, OnInit, Input } from '@angular/core';

import { HistoryService,
         HISTORY_LIST_ENTITY,
         NEGOCIO_COLUMN_NAME } from '../../../services/history-service';

import { Router } from '@angular/router';
import { PATH_COLABORADOR_DETAIL } from '../../../navigation/navigation.module';

@Component({
  selector: 'app-history-list',
  templateUrl: './history-list.component.html',
  styleUrls: ['./history-list.component.scss']
})
export class HistoryListComponent implements OnInit {

  @Input('Entity') ListEntity = null;
  @Input('History') History = [];

  private HISTORY_LIST_ENTITY = HISTORY_LIST_ENTITY;

  constructor(private router: Router) { }

  ngOnInit() {

  }

  onSelectColaborador(colaborador) {
    this.router.navigate([PATH_COLABORADOR_DETAIL, colaborador.UserId]);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/history-list/history-list.component.ts